import * as actionTypes from './action-types';

import { defineAction } from 'store/common/action-helpers';

export const setSmartRoute = object => defineAction(actionTypes.SET_SMART_ROUTE, object);

export const setToDefault = fieldName =>
  defineAction(actionTypes.SET_TO_DEFAULT, { field: fieldName });



// WEBPACK FOOTER //
// ./src/store/features/smart-route/actions.js